var map = {
	"./Knowlege-base-banner_C_3_0913.png": 5839,
	"./SGM/SGM.png": 7711,
	"./SGM/SGMpic.jpg": 5095,
	"./foot.jpg": 9680,
	"./home/logo-Delta.png": 910,
	"./home/logo-蓝色.png": 5535,
	"./home/功能块.png": 6755,
	"./home/手册.png": 8587,
	"./home/框架.png": 2862,
	"./home/程序.png": 7312,
	"./industry/包装.jpg": 7733,
	"./industry/多线切.jpg": 4211,
	"./industry/机器人.jpg": 6439,
	"./industry/橡塑.jpg": 4045,
	"./industry/流体.jpg": 5167,
	"./industry/绕线机.jpg": 3877,
	"./logo-w-cn.svg": 6447,
	"./logo.png": 3153,
	"./sp/内绕机.png": 736,
	"./sp/包装.png": 7400,
	"./sp/多线切.png": 5716,
	"./sp/机器人.png": 7052,
	"./sp/橡塑.png": 7848,
	"./sp/流体.png": 6858,
	"./technology/修标.jpg": 4734,
	"./technology/张力控制.jpg": 6019,
	"./technology/视觉对位.jpg": 5462,
	"./user.png": 6822,
	"./分拣.png": 3493,
	"./半导体.png": 6559,
	"./图片1.jpg": 4992,
	"./旋蓋機帶LOGO.png": 4932,
	"./柔性供料.png": 3187,
	"./硅钢片.jpg": 8370,
	"./立绕机.png": 80
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;